// extracted by mini-css-extract-plugin
module.exports = {"list":"Content_list__35qKs","listItem":"Content_listItem__36qE2"};